import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import styled from '../../../../../theme/styled';

const RejectButton = styled(ButtonTertiaryDark)`
  margin-right: 10px;
  font-size: ${({ theme }) => theme.sizes.m};
`;

export default {
  RejectButton,
};
